<div class="time-entry-create-dialog">
  <h2 mat-dialog-title>
    <fa-icon [icon]="faClock" aria-hidden="true"></fa-icon>
    Add Time Entry
  </h2>

  <mat-dialog-content>
    <form [formGroup]="createForm" class="create-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (createForm.get('date')?.hasError('required')) {
          <mat-error>Date is required</mat-error>
        }
      </mat-form-field>

      <div class="time-row">
        <mat-form-field appearance="outline">
          <mat-label>Start Time</mat-label>
          <input
            matInput
            [type]="useTypedTimeInput ? 'text' : 'time'"
            [attr.inputmode]="useTypedTimeInput ? 'numeric' : null"
            [attr.placeholder]="useTypedTimeInput ? 'HH:mm' : null"
            [appTypedTimeInput]="useTypedTimeInput"
            formControlName="startTime">
          @if (createForm.get('startTime')?.hasError('required')) {
            <mat-error>Start time is required</mat-error>
          }
          @if (createForm.get('startTime')?.hasError('invalidTime')) {
            <mat-error>Use a valid time (e.g. 09:30)</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End Time</mat-label>
          <input
            matInput
            [type]="useTypedTimeInput ? 'text' : 'time'"
            [attr.inputmode]="useTypedTimeInput ? 'numeric' : null"
            [attr.placeholder]="useTypedTimeInput ? 'HH:mm' : null"
            [appTypedTimeInput]="useTypedTimeInput"
            formControlName="endTime">
          @if (createForm.get('endTime')?.hasError('required')) {
            <mat-error>End time is required</mat-error>
          }
          @if (createForm.get('endTime')?.hasError('invalidTime')) {
            <mat-error>Use a valid time (e.g. 17:30)</mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Project</mat-label>
        <mat-select formControlName="projectId">
          <mat-option value="">No project</mat-option>
          @for (project of data.projects; track project.id) {
            <mat-option [value]="project.id">{{ project.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Task</mat-label>
        <mat-select formControlName="taskId">
          <mat-option value="">No task</mat-option>
          @for (task of filteredTasks; track task.id) {
            <mat-option [value]="task.id">{{ task.name }}</mat-option>
          }
        </mat-select>
        @if (filteredTasks.length === 0) {
          <mat-hint>Select a project with tasks to choose a task</mat-hint>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="3"
          formControlName="description"
          placeholder="What did you work on?">
        </textarea>
      </mat-form-field>

      <mat-checkbox formControlName="isBillable">Billable</mat-checkbox>

      @if (data.tagsFeatureEnabled) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Tags</mat-label>
          <input matInput formControlName="tagsText" placeholder="deployment, support">
          <mat-hint>Separate tags with commas</mat-hint>
        </mat-form-field>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="create()">
      <fa-icon [icon]="faPlus" aria-hidden="true"></fa-icon>
      Create Time Entry
    </button>
  </mat-dialog-actions>
</div>
